export enum SurveyDialogResult {
    EndSession = 0,
    TakeSurvey = 1
}